import { render, staticRenderFns } from "./exchangeData.vue?vue&type=template&id=4a89959a&scoped=true&"
import script from "./exchangeData.vue?vue&type=script&lang=js&"
export * from "./exchangeData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a89959a",
  null
  
)

export default component.exports